<template>
    <div style="width: 1300px;margin: 0px auto;">
        <div>
           <div>
                <input value="" v-model="search" style="width:200px" class="el-input__inner" type="text">
                <button @click="sa_article_sour()" type="button" class="el-button el-button--primary" style="width: 120px;margin-bottom: 3px;"><!----><!----><span>搜索资料库</span></button>
                <span style="font-size: 18px;">
                    <b>{{right_div.tit_name}}</b>
                </span>
           </div>
          
        </div>
        
        <div class="el-row">
          <div class="el-col el-col-5">
            <div>
                <ul>
                    <li class="wtq-sty" style="height: auto;border:0px" v-for="item in left_mean">
                        <div  @click="listPage()" style="border-bottom: 1px solid black;height: 27px;">
                            <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_article', query: {id: item.id}}">{{item.name}}</router-link>
                        </div>
                            <ul>
                                <li style="margin-left: 20px;padding:10px 0 10px 0;" class="wtq-sty" v-for="ite in item.ch" @click="listPage()">
                                    <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_type', query: {type_id: ite.id,id: item.id}}">{{ite.type_name}}</router-link>
                                </li>
                            </ul>
                    </li>
                </ul>
            </div>
          </div>
          <div class="el-col el-col-1" style="height:77px">
          
          </div>
          <div class="el-col el-col-18" style="min-height: 777px;margin-bottom: 7px;border: 1px solid #60605896;" >
            <div>
                <div style="text-align: center;">
                    <h1>{{right_div.name}}</h1>
                </div>
                <div class="el-row">
                    <div class="el-col el-col-12" style="padding: 0px 17px" v-for="item in right_div.data">
                        <div style="font-size:20px" class="wtq-sty">
                            <b>{{item.type_name}}</b>
                            <div style="font-size:12px;float:right">
                                <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_type', query: {type_id: item.id}}">更多»</router-link>
                            </div>
                        </div>
                        <div style="margin-left: 27px;">
                            <ul>
                                <li style="color:blue" v-for="ite in item.data">
                                    <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_show', query: {id: ite.id}}">
                                        {{ite.title}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                left_mean:'',
                right_div:'',
            }
        },

        mounted: function () {
            this.search=this.get_get_val('name');
            this.listPage();
        },

        methods: {
            listPage() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                let type_id=this.get_get_val('type_id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_article?id=' + id+'&name='+ this.search+'&type_id='+ type_id,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    _this.right_div=response.data.right_div;
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            sa_article_sour() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_article?id=' + id+'&name='+ this.search,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    _this.right_div=response.data.right_div;
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            // 下载
            downloadMarkOne: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=1'
            },
            downloadMarkTwo: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=2'
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        }
    }
</script>

<style>
    .wtq-sty{
        height: 20px;
        border-bottom: 1px solid #60605896;
        padding: 10px 0 10px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/product/sa_article.vue